// extracted by mini-css-extract-plugin
module.exports = {"Container":"geschichte-module--Container--2_0lL","Content":"geschichte-module--Content--2dFtI"};